import React from 'react';
import ReactPlayer from "react-player"
import { makeStyles } from "@material-ui/core/styles"
import { useStore } from "../../teafuljs/store"
import languageCodes from '../../data/languageCodes.json'

const useStyles = makeStyles(theme => ({
  block: {
    // borderTop: `2px solid ${theme.palette.primary.main}`,
    padding: 25,
  },
  videoContainer: {
    margin: "10px 0 10px 0",
    display: "flex",
    justifyContent: "center",
  },
}))

export default function InstructionalVideo({ hl, youTubeUrl }) {
  const classes = useStyles()
  const language = useStore.language()[0]
  return (
    <div className={classes.block}>
      <div className={classes.videoContainer}>
        <ReactPlayer
          url={youTubeUrl}
          config={{
            youtube: {
              playerVars: { hl: languageCodes[language.toLowerCase()], cc_load_policy: 1 },
            },
          }}
          controls
        />
      </div>
    </div>
  )
}